import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { useState } from "react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";

export const AddFriendWithSlug = ({ children }: { children: React.ReactNode }) => {
    const [onOpen, setOnOpen] = useState(false);
    const [error, setError] = useState('');
    const [slug, setSlug] = useState('');
    const [isSlugValid, setIsSlugValid] = useState(false);

    const validateSlug = (slug: string) => {
        const slugRegex = /^[a-zA-Z0-9-]*$/;
        if(!slug) { setIsSlugValid(false); return false;}
        if(slug.length < 3 || slug.length > 20) {setIsSlugValid(false); return false;}
        if (slugRegex.test(slug)) {setIsSlugValid(true); return true;}
        else {setIsSlugValid(false); return false;}
    };

    const addFriend = async () => {
        const response = await fetch(`__SITE_BASE__/api/me/friends`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                slug: slug
            })
        });
        const data = await response.json();
        if (data.message) return setError(data.message);
        setOnOpen(false);
    };

    return (
        <Dialog open={onOpen} onOpenChange={onOpen => setOnOpen(onOpen)}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 max-h-96 overflow-auto rounded-lg shadow-lg" style={{ scrollbarWidth: "thin", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }}>
                <DialogHeader className="items-start justify-start">
                    <DialogTitle className="text-2xl font-bold">
                        Add Friend
                    </DialogTitle>
                    <DialogDescription />
                </DialogHeader>
                <div className="flex flex-col gap-4 p-6">
                    <div className="flex flex-col gap-2">
                        <label className="text-sm font-medium">Username</label>
                        {error && <div className="text-red-500 text-sm">{error}</div>}
                        <Input
                            className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300 focus:ring-2 focus:ring-brand-green" 
                            id="slug"
                            type="text"
                            autoComplete="off"
                            value={slug}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSlug(value);
                                setIsSlugValid(validateSlug(value));
                            }}
                            placeholder="Enter your friend's username"
                        />
                    </div>
                    <div className="flex justify-end gap-4">
                        <Button
                            className="bg-brand-green px-5 py-2 w-full rounded-lg text-white font-semibold hover:bg-green-500 disabled:bg-brand-darkest transition-all duration-300"
                            onClick={addFriend}
                            disabled={!isSlugValid}
                        >
                            Add Friend
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};
